export enum ImageUpdateActions {
    PartialMatched = 'Partial Matched',
    Matched = 'Matched',
    UnMatched = 'UnMatched',
    Updated = 'Updated'
}